module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ded"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "TXS"
  }), _vm._v(" "), _c('p', {
    staticClass: "TXS"
  }), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("To my friends whose astonishing generosity and sacrifice made possible not just this book but my continued survival.")])]), _vm._v(" "), _c('p', {
    staticClass: "DEDL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I can’t name you all—I don’t even know who all of you are—so I’ll name none. You know who you are.")])]), _vm._v(" "), _c('p', {
    staticClass: "DEDL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Neither words nor riches can ever repay what I owe you. My awe, humility, and gratitude will live so long as I. As will my love.")])]), _vm._v(" "), _c('p', {
    staticClass: "DEDL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Thank you.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-561e2c79","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 66
// module chunks = 0